<template>

    <div :class="['filter-menu', 'filter-' + name ]">

        <div class="filter-label">
            {{ label }}
        </div>

        <div class="filter-double-menu">

            <filter-date
                :selected="selected.from"
                :name="fromName"
                :open="focus == fromName"
                :now="now"
                @apply="applyFrom"
            />

            <filter-date
                :selected="selected.to"
                :name="toName"
                :open="focus == toName"
                :now="selected.from || now"
                @apply="applyTo"
            />

        </div>

    </div>

</template>

<script>

import moment from 'moment';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';

import FilterMixin from '@/mls-filter/mixins/FilterMixin.js';
import FilterDate from '@/mls-filter/components/filters/FilterDate.vue';

export default {

    mixins: [FilterMixin],

    props: {
        options: Object,
        selected: Object,
    },

    computed: {

        ...mapState([
            'focus',
        ]),

        selectedOption() {
            return new Error('Can\'t use selectedOption in filter-fromto.');
        },

        now() {
            return moment().format('YYYY-MM-DD');
        },

        fromName() {
            return this.name + '_from';
        },

        toName() {
            return this.name + '_to';
        },

    },

    methods: {

        getOption(id) {
            throw new Error('Can\'t use getOption in filter-fromto.');
        },

        applyFrom(from) {
            if (from) {
                const m = moment(from).format('YYYY-MM-DD');
                this.$store.dispatch('applyFilterFrom', {filter: this.name, from: m});
            } else {
                this.$store.dispatch('applyFilterFrom', {filter: this.name, from: null});
            }

        },
        applyTo(to) {
            if (to) {
                const m = moment(to).format('YYYY-MM-DD');
                this.$store.dispatch('applyFilterTo', {filter: this.name, to: m});
            } else {
                this.$store.dispatch('applyFilterTo', {filter: this.name, to: null});
            }
        },
    },

    components: {
        'filter-date': FilterDate,
    },
};

</script>


<style lang="scss" scoped>

    @import "@/common/scss/_variables.scss";
    @import "@/common/scss/_mixins.scss";

    .filter-double-menu {
        // w-100 d-flex position-relative
        width: 100%;
        display: flex;
        margin: 0 -4px;

        @include media-breakpoint-up(md) {
            position: relative;
        }

        .filter-date-container {
            flex-grow: 1;
            flex-basis: 50%;
            padding: 0 4px;
        }
    }

</style>
